import { apiCallback } from 'api';

export default {
  getSlots: apiCallback(
    {
      service: 'slot-orchestration',
      endpoint: 'slot-days',
      verbs: ['get'],
      defaultVersion: 1,
      query: {
        branchId: '${branchId}',
        slotType: '${slotType}',
        customerOrderId: '${customerOrderId}',
        postcode: '${postcode}',
        addressId: '${addressId}',
        fromDate: '${fromDate}',
        size: '${size}',
        slotGridType: '${slotGridType}',
      },
    },
    'get',
  ),
};
